"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEntryRequestToJSON = exports.CreateEntryRequestFromJSONTyped = exports.CreateEntryRequestFromJSON = exports.instanceOfCreateEntryRequest = void 0;
/**
 * Check if a given object implements the CreateEntryRequest interface.
 */
function instanceOfCreateEntryRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "actionId" in value;
    isInstance = isInstance && "participantId" in value;
    isInstance = isInstance && "giveawayId" in value;
    return isInstance;
}
exports.instanceOfCreateEntryRequest = instanceOfCreateEntryRequest;
function CreateEntryRequestFromJSON(json) {
    return CreateEntryRequestFromJSONTyped(json, false);
}
exports.CreateEntryRequestFromJSON = CreateEntryRequestFromJSON;
function CreateEntryRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'actionId': json['actionId'],
        'participantId': json['participantId'],
        'giveawayId': json['giveawayId'],
    };
}
exports.CreateEntryRequestFromJSONTyped = CreateEntryRequestFromJSONTyped;
function CreateEntryRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'actionId': value.actionId,
        'participantId': value.participantId,
        'giveawayId': value.giveawayId,
    };
}
exports.CreateEntryRequestToJSON = CreateEntryRequestToJSON;
